import React from 'react';
import styles from './FormFilter.module.scss';
import AddressFilterCard from '../../ui/AddressFilterCard/AddressFilterCard';
import PeriodSelectionFilterCard from '../../ui/PeriodSelectionFilterCard/PeriodSelectionFilterCard';
import CriteriaFilterCard from '../../ui/CriteriaFilterCard/CriteriaFilterCard';

const FormFilter = () => {
  return (
    <div className={styles.root}>
      <PeriodSelectionFilterCard />
      <CriteriaFilterCard />
      <AddressFilterCard />
    </div>
  );
};

export default FormFilter;
